/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" {...props}>
    <title>Moon Icon</title>
    <path
      d="M19 10.52c-.158 1.706-.798 3.622-1.846 4.977a9.02 9.02 0 0 1-9.098 3.286 9.02 9.02 0 0 1-6.84-6.84 9.02 9.02 0 0 1 3.286-9.098A9.02 9.02 0 0 1 9.189 1C8.19 2.351 7.71 4.016 7.835 5.691s.847 3.251 2.035 4.439 2.763 1.91 4.439 2.035 3.34-1.147 4.691-2.146v.501z"
      strokeLinejoin="round"
    />
  </svg>
);
